import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { PublicHeader } from '@/components/PublicHeader';
import { PublicFooter } from '@/components/PublicFooter';
import SergeantTapInMotion from '@/components/in-motion/SergeantTapInMotion';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/*
 * Shareable public page: the native interactive "Sergeant TAP In Motion" presentation is the
 * default content, inside the normal PublicHeader / PublicFooter chrome. Defaults to Job Seekers;
 * ?audience=employer is honored and kept in sync with the internal switch.
 */
function InActionPage() {
  const params = new URLSearchParams(useLocation().search);
  const initialAudience = params.get('audience') === 'employer' ? 'employer' : 'seeker';
  const [c, setC] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/homepage-content`).then((r) => setC(r.data)).catch(() => setC({}));
  }, []);

  if (!c) return null;

  return (
    <div className="min-h-screen bg-white" data-testid="in-action-page">
      <PublicHeader />
      <SergeantTapInMotion
        initialAudience={initialAudience}
        syncAudienceToUrl
        seekerHref={c.job_seekers_cta_url || '/auth?mode=role-select'}
        employerHref={c.employers_cta_url || '/partner?source=employer'}
      />
      <PublicFooter />
    </div>
  );
}

export default InActionPage;
